<template>
  <section class="unify_7">
    <div class="title_7">
      <h4>端云一体</h4>
    </div>

    <ul class="unify_box_7">
      <li class="unify_item_7">
        <div bg-url="@/plan/assets/image/7/flyme_id.png" v-bg class="icon_7"></div>
        <h5>Flyme ID</h5>
        <p>生态应用的统一账号载体<br />多终端账号互通<br />极高的安全风控能力</p>
      </li>

      <li class="unify_item_7">
        <div bg-url="@/plan/assets/image/7/pay.png" v-bg class="icon_7"></div>
        <h5>Flyme 支付</h5>
        <p>功能完善的支付 SDK<br />安全的支付渠道<br />丰富的支付场景</p>
      </li>

      <li class="unify_item_7">
        <div bg-url="@/plan/assets/image/7/push.png" v-bg class="icon_7"></div>
        <h5>PUSH</h5>
        <p>通道稳定高触达<br />支持多种推送方式<br />智能化精准推送</p>
      </li>

      <li class="unify_item_7">
        <div bg-url="@/plan/assets/image/7/unify.png" v-bg class="icon_7"></div>
        <h5>统一运营平台</h5>
        <p>一站式云端运营<br />权限管控灵活多样<br />丰富数据赋能运营</p>
      </li>

      <li class="unify_item_7">
        <div bg-url="@/plan/assets/image/7/big_data.png" v-bg class="icon_7"></div>
        <h5>大数据</h5>
        <p>车联网画像<br />数据可视化平台<br />核心数据看盘服务<br />软件监控和诊断服务</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Unify',
}
</script>

<style lang="less" scoped>
.unify_7 {
  height: 1215px;
  background-color: #F7F8FA;
}

.title_7 {
  width: 1200px;
  padding: 100px 0 50px 0;
  margin: auto;

  h4 {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;
    text-align: center;
    color: #000;
  }
}

.unify_box_7 {
  margin: auto;
  width: 1200px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.unify_item_7 {
  width: 384px; 
  height: 420px;
  border-radius: 24px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 20px 0 0;

  &:nth-child(3) {
    margin-right: 0;
  }

  .icon_7 {
    width: 90px;
    height: 90px;
    margin-top: 70px;
    background-size: 100% 100%;
  }

  h5 {
    font-weight: 600;
    font-size: 26px;
    line-height: 37px;
    text-align: center;
    color: #000000;
    margin: 30px 0 10px 0;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
  }
}

</style>
